<template xmlns="http://www.w3.org/1999/html">
  <div>
    <div class="columns">
      <div class="column is-12">
        <div class="is-flex flex-wrap">
          <div class="field mr-4">
            <label class="label">Header image</label>
            <figure class="image is-150x150 is-pulled-left">
              <img
                v-if="headerImage"
                :src="headerImage"
              >
              <img
                v-if="!headerImage"
                src="/images/img_default.jpg"
              >
            </figure>
          </div>
          <div class="field mr-4">
            <label class="label">Large preview</label>
            <figure class="image is-150x150 is-pulled-left">
              <img
                v-if="largePreview"
                :src="largePreview"
              >
              <img
                v-if="!largePreview"
                src="/images/img_default.jpg"
              >
            </figure>
          </div>
          <div class="field">
            <label class="label">Small Preview</label>
            <figure class="image is-150x150 is-pulled-left">
              <img
                v-if="smallPreview"
                :src="smallPreview"
              >
              <img
                v-if="!smallPreview"
                src="/images/img_default.jpg"
              >
            </figure>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <h4 class="subtitle is-4">
          Header Image
        </h4>
        <vue-dropzone
          id="dropzone"
          ref="headerImage"
          :options="dropzoneOptions"
          @vdropzone-success="getHeaderImageLink"
        />
        <input
          v-model="title"
          class="input"
          type="text"
          placeholder="Title"
        >
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <h4 class="subtitle is-4">
          Preview
        </h4>
        <div class="is-flex flex-wrap">
          <div class="field">
            <label class="label">Large Preview</label>
            <div class="control">
              <vue-dropzone
                id="dropzonePreviewLarge"
                ref="largePreview"
                :options="dropzoneOptions"
                @vdropzone-success="getLargePreviewLink"
              />
            </div>
          </div>
          <div class="field">
            <label class="label">Small Preview</label>
            <div class="control">
              <vue-dropzone
                id="dropzonePreviewSmall"
                ref="smallPreview"
                :options="dropzoneOptions"
                @vdropzone-success="getSmallPreviewLink"
              />
            </div>
          </div>
        </div>
        <div class="field">
          <label class="label">Preview Text</label>
          <div class="control">
            <textarea
              v-model="previewText"
              class="textarea"
              type="text"
              placeholder="Preview Text"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div
        id="message-feed"
        class="column is-12"
      >
        <froala
          v-model="value"
          :tag="'textarea'"
          :config="config"
        />
      </div>
    </div>
    <div
      class="columns"
      @click="showAllRegions = !showAllRegions"
    >
      <div class="column is-12">
        <div class="field">
          <div class="control">
            <label class="checkbox">
              <input
                type="checkbox"
                :checked="showAllRegions"
              >
              Show for all regions
            </label>
          </div>
        </div>
      </div>
    </div>
    <div
      class="columns"
      @click="activeArticle = !activeArticle"
    >
      <div class="column is-12">
        <div class="field">
          <div class="control">
            <label class="checkbox">
              <input
                type="checkbox"
                :checked="activeArticle"
              >
              Active Article
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <div class="field is-grouped">
          <div class="control">
            <a
              type="button"
              class="button is-info"
              @click="createNews()"
            >Submit</a>
          </div>
          <div class="control">
            <router-link
              to="/admin/ahl-news"
              class="button is-link"
            >
              Cancel
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import vueDropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import axios from 'axios'

  export default {
    name: 'ToolsNewsCreate',
    components: {
      vueDropzone
    },
    props: ['user', 'token'],
    data() {
      return {
        title: '',
        value: '',
        headerImage: '',
        largePreview: '',
        smallPreview: '',
        previewText: '',
        showAllRegions: false,
        activeArticle: false,
        images: [],
        dropzoneOptions: {
          url: '//rest.ahlpoker.com/image/upload',
          thumbnailWidth: 150,
          maxFilesize: 10,
          paramName: 'file',
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560'
          },
          success: (file, res) => {
            if (file.previewElement) {
              return file.previewElement.classList.add('dz-success')
            }
            console.log(this)
            JSON.parse(res).link
          }
        },
        config: {
          key: 'GPD2tA17B2A2C1A1B1sqyI-7cB-22C-16seD2zuvc1A6B5A4D3A3B2B2G3A4A3==',
          imageUploadParam: 'file',
          imageUploadURL: 'https://rest.ahlpoker.com/image/upload',
          imageUploadParams: {
            id: 'my_editor',
            token: ''
          },
            imageUpload: true,
          imageUploadMethod: 'POST',
          imageMaxSize: 5 * 1024 * 1024,
          imageAllowedTypes: ['jpeg', 'jpg', 'png'],
            imageManagerLoadMethod: 'GET',
          imageManagerLoadURL: 'https://rest.ahlpoker.com/image/getlist',
          imageManagerDeleteURL: 'https://rest.ahlpoker.com/image/delete',
          events: {
            'froalaEditor.image.loaded': (e, editor, $img) => {
              this['_data'].images.push($img[0].src)
            },
            'froalaEditor.image.removed': (e, editor, $img) => {
              let index = this['_data'].images.find((image) => {
                return image === $img[0].src
              })
              this['_data'].images.splice(index, 1)
            }
          }
        }
      }
    },
    created() {
      if (!this.user || !this.user.isHost) this.$router.push({name: 'FourZeroFour'})
    },
    methods: {
      getHeaderImageLink(file, res) {
        this.headerImage = res.link
        this.$refs.headerImage.removeAllFiles()
      },
      getLargePreviewLink(file, res) {
        this.largePreview = res.link
        this.$refs.largePreview.removeAllFiles()
      },
      getSmallPreviewLink(file, res) {
        this.smallPreview = res.link
        this.$refs.smallPreview.removeAllFiles()
      },
      createNews() {
        this.$axios({
          method: 'POST',
          url: 'ahlnews/save',
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token,
            headerimage: this.headerImage,
            largepreviewimage: this.largePreview,
            smallpreviewimage: this.smallPreview,
            previewtext: this.previewText,
            title: this.title,
            text: this.value,
            showallregions: this.showAllRegions,
            active: this.activeArticle
          }
        })
          .then((res) => {
            console.log(res.data)
            this.$router.push({name: 'Tools', params: {user: this.user}})
          })
          .catch((error) => {
            this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
          })
      }
    }
  }
</script>
